module.exports = __webpack_public_path__ + "static/media/low_battery_sel.64e3ac1d.svg";